import { OrderTableProductData } from '../../../OrdersPage/types';

export enum CollectStatus {
  IN_STOCK = 'in_stock',
  OUT_OF_STOCK = 'out_of_stock',
  LESS = 'less',
  EXPIRY = 'expiry',
  DEFECT = 'defect',
  OTHER_PRICE = 'other_price',
}

export enum CollectTab {
  PENDING = 'pending',
  DONE = 'done',
  PROBLEMS = 'problems',
}

export enum CollectPhase {
  COLLECT = 'collect',
  AGREEMENT = 'agreement',
}

export enum AgreementDecision {
  KEEP = 'keep',
  REMOVE = 'remove',
}

// Причина отсутствия товара (для статуса OUT_OF_STOCK):
// «нет по базе» или «нет по факту» — как в старом флоу out_of_stock
export type OutOfStockReason = 'in_database' | 'in_fact';

export interface ProductMark {
  status: CollectStatus;
  // фактическое количество на полке (для статуса LESS)
  quantity?: number;
  // срок годности в формате ММ.ГГГГ (для статуса EXPIRY)
  expDate?: string;
  // причина брака (для статуса DEFECT)
  defectReason?: string;
  // фактическая цена (для статуса OTHER_PRICE)
  newPrice?: number;
  // причина отсутствия (для статуса OUT_OF_STOCK)
  outOfStockReason?: OutOfStockReason;
}

export interface ProductExtraOptions {
  needReceipt?: boolean;
}

export type ProductMarks = Record<string, ProductMark>;
export type ProductExtras = Record<string, ProductExtraOptions>;
export type AgreementDecisions = Record<string, AgreementDecision>;

export interface CollectProductData extends OrderTableProductData {
  price: number;
  availibilityCount?: number;
  partnerProposal?: {
    sku: string;
    count_desired: number;
    pharmacy_count: number;
  };
}

export interface CollectCounts {
  all: number;
  pending: number;
  done: number;
  problems: number;
}
